import UserMetaData from "./UserMetaData";
import MenuButtonController from "../menu-button-actions/MenuButtonController";

import "./css/header-info.css";

const HeaderInfo = (props) => {
    return (
        <div className="header-info">
            <UserMetaData
                displayingFor={props.displayingFor}
                userId={props.userId}
                name={props.name}
                askedOn={props.askedOn}
                updatedOn={props.updatedOn}
            />

            <MenuButtonController
                data={props.data}
                isUserAuthenticated={props.isUserAuthenticated}
            />
        </div>
    );
}

export default HeaderInfo;